import { makeStyles } from '@itsa.io/ui';

export default makeStyles(theme => ({
	root: {},
	radioGroup: {
		justifyContent: 'space-between',
		paddingRight: theme.spacing(3),
	},
}));
